const commerceStatusIndex = {
	'1': { color: 'warning', status: 'open', text: 'Sıraya Alındı' },
	'2': { color: 'warning', status: 'open', text: 'Hazırlanıyor' },
	'3': { color: 'warning', status: 'open', text: 'Hazırlandı' },
	'4': { color: 'success', status: 'open', text: 'Teslim Edildi' },
	'5': { color: 'warning', status: 'open', text: 'İade Edildi' },
}

export default commerceStatusIndex